module.exports = __webpack_public_path__ + "static/media/404.647c25d9.svg";